import React from 'react';
import { Create, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import AffectationForm from './detail/AffectationForm';

const AffectationCreate = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.create', {
      resource: translate('resources.affectation.name', { smart_count: 1 }),
    }),
  );
  return (
    <Create {...props} redirect="show">
      <AffectationForm create />
    </Create>
  );
};

export default AffectationCreate;
